import { useEffect, useRef, useState } from "react";

function YoutubeComponent({
  downloaded_path,
  muted,
  url,
  creatorName,
  videoRef,
  caption,
  onManualMute,
  onManualUnmute,
  isAutoPlay = true,
  rounded,
}) {
  if (!url) return <p>Invalid URL</p>;

  const localRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(muted); // Initially set to the prop value
  const [showOverlay, setShowOverlay] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const encodedPath = `https://genz-staging.feeltiptop.com/${downloaded_path}`;

  useEffect(() => {
    const videoEl = localRef.current;
    if (videoEl) {
      videoEl.muted = muted;
      setIsMuted(muted);
    }
  }, [muted]);

  useEffect(() => {
    const videoEl = localRef.current;
    if (videoRef) videoRef(videoEl);

    if (!videoEl) return;

    // Update play/pause state based on actual video events
    const handlePlay = () => setIsPlaying(true);
    const handlePause = () => setIsPlaying(false);

    videoEl.addEventListener("play", handlePlay);
    videoEl.addEventListener("pause", handlePause);

    // Ensure to clean up the event listeners
    return () => {
      videoEl.removeEventListener("play", handlePlay);
      videoEl.removeEventListener("pause", handlePause);
    };
  }, [videoRef]);

  const handlePlayPause = () => {
    const videoEl = localRef.current;
    if (videoEl) {
      if (isPlaying) {
        videoEl.pause();
      } else {
        videoEl.play();
      }
    }
  };

  const handleMuteToggle = (e) => {
    // Prevent the click event from propagating to the parent div (which is handling play/pause)
    e.stopPropagation();

    const videoEl = localRef.current;
    if (videoEl) {
      const willBeMuted = !videoEl.muted;
      videoEl.muted = willBeMuted;
      setIsMuted(willBeMuted); // Sync local muted state
      if (willBeMuted) {
        onManualMute?.(); // Inform parent to mute all
      } else {
        onManualUnmute?.(); // Inform parent to unmute all
      }
    }
  };

  // const handleMuteToggle = (e) => {
  //   // Prevent the click event from propagating to the parent div (which is handling play/pause)
  //   e.stopPropagation();

  //   const videoEl = localRef.current;
  //   if (videoEl) {
  //     videoEl.muted = !videoEl.muted;
  //     setIsMuted(videoEl.muted);
  //     if (!videoEl.muted && handleManualUnmute) {
  //       handleManualUnmute(); // Trigger global unmute
  //     } else {
  //       handleManualMute(); // Trigger global mute
  //     }
  //   }
  // };

  // Truncate caption text if it's too long
  const maxCaptionLength = 100; // Max length before truncation
  const truncatedCaption =
    caption && caption.length > maxCaptionLength
      ? caption.substring(0, maxCaptionLength) + "..."
      : caption;

  return (
    <div
      className={`relative flex ${rounded && "rounded-lg"} aspect-[1/1.75] h-full w-full cursor-pointer items-center justify-center overflow-hidden bg-black`}
      onClick={handlePlayPause} // Make the entire area clickable for play/pause
    >
      <video
        ref={localRef}
        src={encodedPath}
        muted={muted} // Ensure it is muted as per the global setting
        {...(isAutoPlay ? { autoPlay: true } : {})}
        loop
        className="w-full object-cover"
        playsInline
        webkit-playsinline="true"
      />

      {showOverlay && (
        <div
          style={{
            position: "absolute",
            bottom: "2rem",
            left: "1rem",
            right: "1rem",
            color: "white",
            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.7)",
            fontSize: "12px",
            zIndex: 30,
          }}
        >
          {creatorName && (
            <p
              style={{
                marginDown: "1rem",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              @{creatorName}
            </p>
          )}
          {caption && (
            <div>
              {!isExpanded && (
                <p style={{ margin: 0, textAlign: "left" }}>
                  {truncatedCaption}
                  {caption.length > maxCaptionLength && (
                    <button
                      onClick={() => setIsExpanded(true)}
                      style={{
                        background: "transparent",
                        color: "#fff",
                        border: "none",
                        fontSize: "14px",
                        fontWeight: "bold",
                        cursor: "pointer",
                        textDecoration: "underline",
                        paddingLeft: "4px",
                      }}
                    >
                      more
                    </button>
                  )}
                </p>
              )}
              {isExpanded && (
                <ExpandedCaption
                  caption={caption}
                  onCollapse={() => setIsExpanded(false)}
                />
              )}
            </div>
          )}
        </div>
      )}
      {/* Darker overlay with smooth transition when video is paused */}
      <div
        className={`absolute inset-0 bg-black transition-opacity duration-500 ${isPlaying ? "opacity-0" : "opacity-60"}`}
      ></div>
      {/* Mute/Unmute Button */}
      <button
        onClick={handleMuteToggle}
        className="absolute right-2 top-2 rounded-full bg-gray-700 p-2 text-white"
      >
        {isMuted ? "🔇" : "🔊"}
      </button>
    </div>
  );
}

export default YoutubeComponent;
